export var FLEX_CLASS_PREFIX = 'Flex';
export var FLEX_ITEM_CLASS_PREFIX = 'FlexItem';
export var flexRoot = 'FlexRoot';
export var flexItemRoot = 'FlexItemRoot';